import useAuth from "~/hooks/useAuth"

export default function useBeardCounts(options = {}) {
    const { isLoggedIn } = useAuth()
    return ReactQuery.useQuery({
        enabled: isLoggedIn,
        queryKey: ['beard', 'counts'],
        queryFn: () => accountAction.fetchCounts(),
        refetchInterval: 1000 * 15,
        initialData: { 
            notifications: 0, 
            subscriptions: 0, 
            subscriptions_unviewed: 0, 
            requests: 0, 
            requests_unviewed: 0, 
            flights: 0,
            flights_unviewed: 0,
        },
        ...options,
    })

}
